<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        {{ $t('sheet.sheet_components.stop_sell.title') }}
    </th>
    <template v-for="day in prices">
        <td class="sheet-cell pa-0 text-center">
            <v-progress-circular v-if="loading_date == day.date" size="12" width="2" indeterminate />
            <v-icon v-else large v-text="day.stop_sell ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="day.stop_sell ? 'red' : 'grey darken-1'" @click="day.stop_sell = !day.stop_sell; save(day)" />
        </td>
    </template>
</tr>
</template>
<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        prices: Object,
        backup_sheet: [Object, Array],
        params: Object
    },
    data() {
        return {
            loading: false,
            loading_date: null
        }
    },
    methods: {
        ...mapActions('alert', ['success', 'error']),

        save(day) {
            this.loading_date = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                stop_sell: day.stop_sell
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].stop_sell = day.stop_sell
                })
                .catch(error => {
                    console.log(error);
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].stop_sell = !day.stop_sell
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date = null;
                });
        }
    }
}
</script>
